// ======================================================================
// InventoryValuationPage.jsx
// PPE → Inventory → Reports → Inventory Valuation
// ======================================================================

import React, { useEffect, useState } from "react";
//import { fetchInventoryValuation } from "./inventoryValuationService";
import {
  fetchInventoryValuation,
  exportInventoryValuationExcel
} from "./inventoryValuationService";

import ERPReportLayout from
"../../../../components/reports/ERPReportLayout";

import ERPFilterBar from
"../../../../components/reports/ERPFilterBar";

import ERPDataGrid from
"../../../../components/reports/ERPDataGrid";

import ERPReportActions from
"../../../../components/reports/ERPReportActions";

import "../../../../components/reports/reportStyles.css";

export default function InventoryValuationPage() {

  const [rows, setRows] = useState([]);
  const [totalValue, setTotalValue] = useState(0);
  const [loading, setLoading] = useState(false);

  const [filters, setFilters] = useState({
    material: "",
    batch: ""
  });
const [currentPage, setCurrentPage] = useState(1);

const [pageSize, setPageSize] = useState(20);

  // ------------------------------------------------
  // LOAD DATA
  // ------------------------------------------------
  const loadData = async () => {
    setLoading(true);
    try {
      const data = await fetchInventoryValuation(filters);
      setRows(data.rows || []);
      setTotalValue(data.total_inventory_value || 0);
      setCurrentPage(1);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  // ------------------------------------------------
  // EXPORT HANDLER
  // ------------------------------------------------
  const handleExport = async (format) => {

  try {

    if (format !== "xlsx") {
      alert("PDF export not implemented yet");
      return;
    }

    const blob =
      await exportInventoryValuationExcel(filters);

    const url =
      window.URL.createObjectURL(
        new Blob([blob])
      );

    const link =
      document.createElement("a");

    link.href = url;

    link.setAttribute(
      "download",
      "inventory_valuation.xlsx"
    );

    document.body.appendChild(link);

    link.click();

    link.remove();

  } catch (err) {

    console.error(err);

    alert(
      "Failed to export report"
    );
  }
};
  
const totalPages = Math.ceil(
  rows.length / pageSize
);

const paginatedRows = rows.slice(
  (currentPage - 1) * pageSize,
  currentPage * pageSize
);

const pageNumbers = Array.from(
  { length: totalPages },
  (_, i) => i + 1
).filter(
  page =>
    page >= currentPage - 2 &&
    page <= currentPage + 2
);
  // ------------------------------------------------
  // GRID COLUMN CONFIG (ERP STANDARD)
  // ------------------------------------------------
  const columns = [
    {
      key: "material_name",
      label: "Material",
      bold: true,
    },
    {
      key: "material_type",
      label: "Type",
    },
    {
      key: "batch_no",
      label: "Batch",
      render: r => r.batch_no || "-"
    },
    {
      key: "available_qty",
      label: "Available Qty",
      align: "right",
      render: r => Number(r.available_qty || 0).toFixed(2)
    },
    {
      key: "avg_rate",
      label: "Avg Rate",
      align: "right",
      render: r => `₹ ${Number(r.avg_rate || 0).toFixed(2)}`
    },
    {
      key: "stock_value",
      label: "Stock Value",
      align: "right",
      bold: true,
      render: r =>
        `₹ ${Number(r.stock_value || 0).toLocaleString()}`
    },
  ];

  // ------------------------------------------------
  // FILTER BAR
  // ------------------------------------------------
  const filterBar = (
    <ERPFilterBar
      left={
        <>
          <input
            placeholder="Material"
            className="erp-filter"
            onChange={(e) =>
              setFilters(prev => ({
                ...prev,
                material: e.target.value
              }))
            }
          />

          

          <input
            placeholder="Batch"
            className="erp-filter"
            onChange={(e) =>
              setFilters(prev => ({
                ...prev,
                batch: e.target.value
              }))
            }
          />

          <button
            onClick={loadData}
            className="erp-primary-btn"
          >
            Load Report
          </button>
        </>
      }

      right={
        <div className="flex items-center gap-4">

          <div className="text-sm whitespace-nowrap">
            Total Inventory Value :
            <strong className="ml-1 text-indigo-600">
              ₹ {Number(totalValue).toLocaleString()}
            </strong>
          </div>

          <ERPReportActions onExport={handleExport} />

        </div>
      }
    />
  );

  // =====================================================
  // UI
  // =====================================================
  return (
    <ERPReportLayout
      title="Inventory — Valuation Report"
      subtitle="Current financial value of inventory"
      toolbar={filterBar}
    >

      <ERPDataGrid
        columns={columns}
         rows={paginatedRows}
        loading={loading}
      />
<div className="d-flex justify-content-between align-items-center mt-3 flex-wrap"> <div> Showing{" "} {(currentPage - 1) * pageSize + 1} {" - "} {Math.min( currentPage * pageSize, rows.length )} {" of "} {rows.length} {" records"} </div> <div className="d-flex align-items-center gap-2"> <span>Rows:</span> <select className="form-select form-select-sm" style={{ width: "90px" }} value={pageSize} onChange={(e) => { setPageSize(Number(e.target.value)); setCurrentPage(1); }} > <option value={20}>20</option> <option value={50}>50</option> <option value={100}>100</option> </select> <button className="btn btn-sm btn-outline-secondary" disabled={currentPage === 1} onClick={() => setCurrentPage(1)} > {"<<"} </button> <button className="btn btn-sm btn-outline-secondary" disabled={currentPage === 1} onClick={() => setCurrentPage(currentPage - 1) } > {"<"} </button> {pageNumbers.map((page) => ( <button key={page} className={ page === currentPage ? "btn btn-sm btn-primary" : "btn btn-sm btn-outline-secondary" } onClick={() => setCurrentPage(page) } > {page} </button> ))} <button className="btn btn-sm btn-outline-secondary" disabled={currentPage === totalPages} onClick={() => setCurrentPage(currentPage + 1) } > {">"} </button> <button className="btn btn-sm btn-outline-secondary" disabled={currentPage === totalPages} onClick={() => setCurrentPage(totalPages) } > {">>"} </button> </div> </div>

    </ERPReportLayout>
  );
}
